import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { gaPageView } from "../lib/ga";

export const GaPageViews = () => {
  const location = useLocation();
  useEffect(() => {
    gaPageView(location.pathname, document.title);
  }, [location.pathname]);
  return null;
};
